import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '../services/Token.service';
import { SETTINGS } from '../settings';

export function skipInterceptor(interceptorType: string): boolean {
    if (SETTINGS.skipInterceptors.indexOf('ALL') !== -1) {
        return true;
    }
    return SETTINGS.skipInterceptors.indexOf(interceptorType) !== -1;
}

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private tokenService: TokenService
  ) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (skipInterceptor('TOKEN')) {
        return next.handle(request);
    }
    const accessToken: string = this.tokenService.accessToken;
    if (accessToken !== null) {
      request = request.clone({
        setHeaders: {
          Token: accessToken
        }
      });
    }
    return next.handle(request);
  }
}
